<template>
  <div>
    <md-dialog
      :md-active="formShow"
      class="md-scrollbar small-dialog"
    >
      <div class="table-data__tool mb-1">
        <md-dialog-title class="able-data__tool-left">{{ formTitle }}</md-dialog-title>
      </div>

      <md-content class="md-scrollbar" style="overflow: auto;">
        <template v-if="loading">
          <div class="d-flex justify-content-center align-items-center" style="min-height: 150px; ">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
        </template>
        <template v-else>
          <fieldset :disabled="formMode === 'view'">
            <form action method="post" enctype="multipart/form-data" class="form-horizontal p-3">
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="created_at" class="form-control-label" v-required>Price Date</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="created_at"
                    name="created_at"
                    placeholder
                    class="form-control"
                    v-model="input.created_at"
                    readonly
                    disabled
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="unit_price" class="form-control-label" v-required>Unit Price</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="unit_price"
                    name="unit_price"
                    placeholder
                    class="form-control"
                    v-model="input.unit_price"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="currency" class="form-control-label" v-required>Currency</label>
                </div>
                <div class="col-12 col-md-9">
                  <select
                    id="currency"
                    name="currency"
                    placeholder
                    class="form-control"
                    ref="currency"
                    v-model="input.currency"
                  >
                    <option
                      v-for="currency in currencyOptions"
                      :value="currency"
                      :key="currency"
                    >{{currency}}</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="quantity" class="form-control-label" v-required>Quantity</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="quantity"
                    name="quantity"
                    placeholder
                    class="form-control"
                    v-model="input.quantity"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="terms" class="form-control-label" v-required>Terms</label>
                </div>
                <div class="col-12 col-md-9">
                  <select
                    id="terms"
                    name="terms"
                    placeholder
                    class="form-control"
                    ref="terms"
                    v-model="input.terms"
                  >
                    <option
                      v-for="term in termsOptions"
                      :value="term"
                      :key="term"
                    >{{term}}</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="remarks" class="form-control-label">Remarks</label>
                </div>
                <div class="col-12 col-md-9">
                  <textarea
                    name="remarks"
                    id="remarks"
                    rows="4"
                    placeholder
                    class="form-control"
                    v-model="input.remarks"
                  ></textarea>
                </div>
              </div>
            </form>
          </fieldset>
          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="save()"
              v-if="formMode != 'view'"
            >Save</md-button>
            <md-button class="md-primary" @click="$emit('closeVendorProjectHistoryEdit')">Cancel</md-button>
          </md-dialog-actions>
        </template>
      </md-content>
    </md-dialog>
  </div>
</template>

<script>

import save from 'src/global/save.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import VendorProjectHistoryModel from './model/VendorProjectHistory'

export default {
  name: 'VendorProjectHistoryEdit',
  props: {
    formMode: String,
    formShow: Boolean,
    selectedVendorProject: Object,
    selectedItem: Object,
  },
  data() {
    return { 
      
      input: VendorProjectHistoryModel(),
      requiredInput: [
        {key: 'unit_price', title: 'Vendor Code'},
        {key: 'currency', title: 'Currency'},
        {key: 'quantity', title: 'Quantity'},
        {key: 'terms', title: 'Terms'},
      ],
      edit: false,
      datas: null,
      processing: false,
      loading: false,
      modelID: null,
      currencyOptions: ['HKD', 'RMB'],
      termsOptions: ['EXW', 'CIF', 'CND', 'Other'],
    }
  },
  computed: {
    formTitle: function () {
      if (this.selectedVendorProject)
        return 'Add new record in ' + this.selectedVendorProject.ref_no
      else
        return ''
    }
  },
  watch: {
    formShow: function() {
      this.input = VendorProjectHistoryModel()
    },
    selectedItem: function (data) {
      if (data) {
        this.modelID = data.id
        this.$http
          .get(this.WebService.vendorprojectHistory + '/' + data.id)
          .then((res) => {
            this.input = res.data.data
          })
      } else {
        this.input = VendorProjectHistoryModel()
      }
    },
  },
  methods: {
    validation,
    save() {

      if( this.processing !== false ) return

      if( typeof this.validation !== 'undefined' && this.validation() ) {

        this.processing = true

        this.input.vendor_project_id = this.selectedVendorProject.id
        
        if (this.input.id) {
          this.$http
            .put(this.WebService.vendorprojectHistory + '/' + this.input.id, this.input)
            .then((res) => {
              this.input = res.data
              this.$emit('closeVendorProjectHistoryEdit')
              this.$emit('reload')
            })
            .catch((err) => {
              this.alertNotice({
                type: 'danger',
                title: 'Failed',
                content: err.data,
              })
            })
            .finally(() => {
              this.processing = false
            })
        } else {
          this.$http
            .post(this.WebService.vendorprojectHistory, this.input)
            .then((res) => {
              this.$emit('closeVendorProjectHistoryEdit')
              this.$emit('reload')
            })
            .catch((err) => {
              this.alertNotice({
                type: 'danger',
                title: 'Failed',
                content: err.data,
              })
            })
            .finally(() => {
              this.processing = false
            })
        }
      }
    },
  }
}
</script>